import { render, staticRenderFns } from "./CoralsolOcorrenciasForm.vue?vue&type=template&id=33563223&scoped=true&"
import script from "./CoralsolOcorrenciasForm.vue?vue&type=script&lang=js&"
export * from "./CoralsolOcorrenciasForm.vue?vue&type=script&lang=js&"
import style0 from "./CoralsolOcorrenciasForm.vue?vue&type=style&index=0&id=33563223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33563223",
  null
  
)

export default component.exports